"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  // Internal Addresses - from Eggs to Eggs
  // BCC on all emails so we can monitor our outbound communication
  communityCareTeamEmailAddress: function communityCareTeamEmailAddress() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      withDisplayName: false
    };
    return this.displayable(options.withDisplayName, 'communitycare@goodeggs.com', options.displayText);
  },
  dispatchEmailAddress: function dispatchEmailAddress(foodhubSlug) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      withDisplayName: false
    };
    return this.displayable(options.withDisplayName, "".concat(foodhubSlug, "-delivery@goodeggs.com"), options.displayText);
  },
  // If option is sent, returns the email with Display text
  displayable: function displayable(withDisplayName, email) {
    var displayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Good Eggs';
    return withDisplayName ? "".concat(displayName, " <").concat(email, ">") : email;
  },
  // External Addresses - for folks outside of Good Eggs
  eaterHelpEmailAddress: function eaterHelpEmailAddress() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      withDisplayName: false
    };
    return this.displayable(options.withDisplayName, 'help@goodeggs.com', options.displayText);
  },
  eaterHelpPhoneNumber: _lodash["default"].constant('(415) 966-4133'),
  emailsEmailAddress: _lodash["default"].constant('emails@goodeggs.com'),
  foodmakerInterestEmailAddress: function foodmakerInterestEmailAddress() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      withDisplayName: false
    };
    return this.displayable(options.withDisplayName, 'sell@goodeggs.com', options.displayText);
  },
  foodmakerOncallEmailAddress: function foodmakerOncallEmailAddress(foodshed) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      withDisplayName: false
    };

    if (foodshed != null) {
      return this.displayable(options.withDisplayName, this.foodshedList(foodshed, 'support+oncall@goodeggs.com'), options.displayText || "The ".concat(foodshed.description || '', " Foodmaker Eggmergency"));
    }

    return this.displayable(options.withDisplayName, 'support+oncall@goodeggs.com', options.displayText || 'The Good Eggs Foodmaker Eggmergency');
  },
  foodmakerTeamEmailAddress: function foodmakerTeamEmailAddress(foodshedOrSlug) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      withDisplayName: false
    };

    if (foodshedOrSlug != null) {
      return this.displayable(options.withDisplayName, this.foodshedList(foodshedOrSlug, 'makers@goodeggs.com'), options.displayText);
    }

    return this.displayable(options.withDisplayName, 'makers@goodeggs.com', options.displayText);
  },
  // Helpers
  foodshedList: function foodshedList(foodshedOrSlug, list) {
    var slug;

    if (typeof foodshedOrSlug === 'string') {
      slug = foodshedOrSlug;
    } else {
      slug = foodshedOrSlug.slug;
    }

    return "".concat(slug || '', "-").concat(list || '');
  },
  grocerySupportEmailAddress: function grocerySupportEmailAddress(foodshedOrSlug) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      withDisplayName: false
    };
    return this.supportEmailAddress({
      foodshedOrSlug: foodshedOrSlug,
      emailPrefix: 'Grocery',
      options: options
    });
  },
  grocerySupportPhoneNumber: _lodash["default"].constant('(650) 297-2118'),
  infoEmailAddress: function infoEmailAddress() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      withDisplayName: false
    };
    return this.displayable(options.withDisplayName, 'info@goodeggs.com', options.displayText || 'The Good Eggs Team');
  },
  ordersEmailAddress: function ordersEmailAddress() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      withDisplayName: false
    };
    return this.displayable(options.withDisplayName, 'orders@goodeggs.com', options.displayText);
  },
  // BCC this address to make sure community care can find it
  outgoingCustomerEmailsEmailAddress: _lodash["default"].constant('outgoing-customer-emails@goodeggs.com'),
  produceSupportEmailAddress: function produceSupportEmailAddress(foodshedOrSlug) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      withDisplayName: false
    };
    return this.supportEmailAddress({
      foodshedOrSlug: foodshedOrSlug,
      emailPrefix: 'Produce',
      options: options
    });
  },
  produceSupportPhoneNumber: _lodash["default"].constant('(650) 314-9233'),
  supportEmailAddress: function supportEmailAddress(_ref) {
    var foodshedOrSlug = _ref.foodshedOrSlug,
        emailPrefix = _ref.emailPrefix,
        options = _ref.options;

    if (foodshedOrSlug != null) {
      var contentToDisplay;

      if (typeof foodshedOrSlug === 'string') {
        contentToDisplay = foodshedOrSlug.toUpperCase();
      } else {
        contentToDisplay = foodshedOrSlug.description;
      }

      return this.displayable(options === null || options === void 0 ? void 0 : options.withDisplayName, this.foodshedList(foodshedOrSlug, "".concat(emailPrefix.toLowerCase(), "-orders@goodeggs.com")), options.displayText || "The ".concat(contentToDisplay || '', " Foodmaker ").concat(emailPrefix, " Team"));
    }

    return this.displayable(options === null || options === void 0 ? void 0 : options.withDisplayName, 'support@goodeggs.com', options.displayText || 'The Good Eggs Foodmaker Team');
  }
};
exports["default"] = _default;